import Scene = Phaser.Scene;
import Image = Phaser.GameObjects.Image;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ImageButton extends Phaser.GameObjects.Container {

    private callback: (() => unknown) | undefined = undefined;

    constructor(scene: Scene, x: number, y: number, imageAtlas: string | undefined, imageKey: string) {
        super(scene);

        this.scene = scene;
        this.x = x * CU.S;
        this.y = y * CU.S;
        const self = this;

        let button: Image;
        if (imageAtlas) {
            button = SpriteUtils.addImage(this.scene, 0, 0, imageAtlas, imageKey).setInteractive();
        } else {
            button = SpriteUtils.addImage(this.scene, 0, 0, imageKey).setInteractive();
        }

        button.on('pointerdown', () => {
            SpriteUtils.scale(button, 1.1);
        });
        button.on('pointerup', () => {
            SpriteUtils.scale(button, 1);
            if (self.callback != null) {
                self.callback();
            }
        });

        button.setOrigin(0.5, 0.5);
        this.add(button);
    }

    public setCallback(callback: () => unknown): void {
        this.callback = callback;
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }
}
